import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetLoanUrlTransactionsUseCase extends UseCase {
  constructor({getLoanUrlTransactionsRequestFactory, httpTransactionsRepository}) {
    super()
    this._getLoanUrlTransactionsRequestFactory = getLoanUrlTransactionsRequestFactory
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute(params) {
    const getLoanUrlTransactionsRequest = this._getLoanUrlTransactionsRequestFactory(params)
    const [error, response] = await this._httpTransactionsRepository.getLoanUrl({getLoanUrlTransactionsRequest})

    if (error) throw error

    return response.toJSON()
  }
}
